// ProtectedRoute.js
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  // Verificamos si el token existe en localStorage
  const isAuthenticated = Boolean(localStorage.getItem("token"));

  // Si no está autenticado, redirigimos a la ruta "/"
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Si está autenticado, mostramos la ruta protegida
  return children;
}
